namespace st.search {
    class ConstantFiltersController implements controllers.IConstantFiltersController {

        group: string = DefaultGroup;
        filters: { [key: string]: string[] };

        static $inject = ['$rootScope', 'stFacetService'];

        constructor($rootScope: angular.IScope, stFacetService: services.IFacetService) {
            $rootScope.$on('stRegisterFacets', (e: angular.IAngularEvent) => {
                stFacetService.addConstantFilters(this.group, this.filters);
            });
        }
    }

    angular.module('st.search')
        .controller('stConstantFiltersCtrl', ConstantFiltersController);
}
